import * as React from 'react';
import {useAppDispatch} from 'app/store/hooks';
import {useAuthenticateMutation} from 'features/authentication/authenticationApi';
import {login, logout} from 'features/user/userSlice';
import Login from './Login';

export default (): JSX.Element => {
  const dispatch = useAppDispatch();
  const [authenticate] = useAuthenticateMutation();

  const onSuccess = async ({accessToken}: {accessToken: string}) => {
    const authenticationResult = await authenticate(accessToken).unwrap();
    dispatch(login(authenticationResult));
  };

  const onFailure = () => {
    dispatch(logout());
  };

  return <Login onSuccess={onSuccess} onFailure={onFailure} />;
};
